// var url = process.env.NODE_ENV == 'development' 
//     ? 'http://localhost:5001/atlas-18495/us-central1/' 
//     : 'https://us-central1-atlas-18495.cloudfunctions.net/';

var LOCAL_URL = 'http://localhost:5001/atlas-18495/us-central1/';
var PRODUCTION_URL = 'https://us-central1-atlas-18495.cloudfunctions.net/';

// var url = LOCAL_URL;
// var url = PRODUCTION_URL;

export default {
    HOST_URL: PRODUCTION_URL
}